export default __webpack_public_path__ + "static/media/language.53336cc5.jpg";